import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import Select from 'components/shared/base_react_select'

const { I18n } = window

const RecipientList = ({ recipients, onChangeClick }) => (
  <>
    {`${I18n.t('comments.will_be_emailed_to')}:`}
    <br />
    <i>
      {recipients.map(r => r.label).join(', ')}
    </i>
    { recipients.map(r => (
      <input
        type="hidden"
        name="current_commment_recipients[]"
        value={r.value}
        key={r.value}
      />
    )) }
    <button type="button" className="ml-2 btn btn-secondary btn-sm" onClick={onChangeClick}>
      {I18n.t('comments.change')}
    </button>
  </>
)

const RecipientSelect = ({ selectedRecipients, availableRecipients, onChange }) => (
  <>
    { `${I18n.t('comments.email_to_people')}:` }
    <Select
      name="current_commment_recipients[]"
      defaultValue={selectedRecipients}
      options={[...availableRecipients, ...selectedRecipients]}
      isMulti
      onChange={onChange}
    />
  </>
)

const CommentRecipients = ({ recipients, users }) => {
  const [editing, setEditing] = useState(false)
  const [recipientCount, setRecipientCount] = useState(recipients.length)
  const validationRef = useRef(null)

  useEffect(() => {
    if (validationRef.current) {
      validationRef.current.setCustomValidity(
        recipientCount === 0 ? I18n.t('comments.recipients_required') : ''
      )
    }
  }, [recipientCount])

  const handleSelectChange = (selected) => {
    setRecipientCount(selected ? selected.length : 0)
  }

  return (
    <div className="comment-recipients recipients">
      { !editing && <RecipientList recipients={recipients} onChangeClick={() => setEditing(true)} /> }
      { editing && (
        <RecipientSelect
          selectedRecipients={recipients}
          availableRecipients={users}
          onChange={handleSelectChange}
        />
      )}
      <input
        ref={validationRef}
        tabIndex={-1}
        autoComplete="off"
        style={{ opacity: 0, height: 0, position: 'absolute', pointerEvents: 'none' }}
        value={recipientCount > 0 ? 'valid' : ''}
        onChange={() => {}}
        required
      />
    </div>
  )
}

CommentRecipients.propTypes = {
  recipients: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
}
export default CommentRecipients
